// extracted by mini-css-extract-plugin
export var bigHoverActionButton = "EjecV";
export var bigHoverActionContainer = "wBMYh";
export var bigHoverActionContainer_Deprecated = "gReZN";
export var mclBigHover = "_sexu";
export var mclCompact = "ULrW7";
export var sclBigHoverActionButton = "YxiXc";